import React, { useMemo } from 'react';
import styled from 'styled-components';
import { PropertyDot } from './property-dot';

const PropertyDotAndTypeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin: ${(props) => props.$marginCSS ?? '8px 0'};
`;

const P = styled.p`
  max-width: 350px;
`;

/**
 * If this is rendered thru "displayPopupAndDoManyOtherThings"
 */
export function PropertyDotAndType(props) {
  const { property } = props;

  const propertyType = useMemo(() => {
    switch (property.propertyType) {
      case 'ltr':
        return 'Long Term Rental';
      case 'hotel':
        return 'Hotel/Timeshare';
      case 'other':
        return 'Other';
      default:
        /**
         * "displayPopupAndDoManyOtherThings" method of rendering this component
         * results in fields with values of "null" being converted to the string "null"
         */
        return property.apn && property.apn !== 'null' ? 'STR' : 'Other';
    }
  }, [property]);

  const status = useMemo(() => {
    /**
     * "displayPopupAndDoManyOtherThings" method of rendering this component
     * results in fields with values of "null" being converted to the string "null"
     */
    if (property.apn && property.apn !== 'null')
      return property.strLicense ? 'Licensed' : 'Unlicensed';
    if (property.live) return 'Unidentified Live STR Listing';
    return 'Unlicensed';
  }, [property]);

  return (
    <PropertyDotAndTypeWrapper $marginCSS={props.marginCSS}>
      <PropertyDot property={property} />
      <P>
        {propertyType} - {status}
      </P>
      {props.children}
    </PropertyDotAndTypeWrapper>
  );
}
